import React, {useState} from 'react'
import {Helmet} from 'react-helmet-async'
import {KTIcon} from '../../../../_metronic/helpers'
import VoucherForm from './modal/VoucherForm'
import VoucherList from './VoucherList'
import FilterVoucher from './FilterVoucher'
import {useFormik} from 'formik'
import {initVoucherFilterValues, IVoucherFilterType} from './_model'
import InputSearchBox from '../../../utils/components/form/InputSearchBox'

const Voucher = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [filterValues, setFilterValues] = useState<Partial<IVoucherFilterType>>({
    sdate: '',
    edate: '',
    userId: null,
    voucherId: null,
  })

  const onFilter = (values: Partial<IVoucherFilterType>) => {
    setFilterValues(values)
  }

  return (
    <>
      <Helmet>
        <title>Voucher</title>
      </Helmet>

      <div className='d-flex justify-content-between align-items-center mb-3 gap-4 flex-wrap'>
        <InputSearchBox
          placeholder='Search'
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />

        <div className='d-flex gap-2'>
          <FilterVoucher onFilter={onFilter} />

          <button
            type='button'
            className='btn btn-primary'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
          >
            <KTIcon iconName='plus' className='fs-2' />
            Create Voucher
          </button>
        </div>
      </div>

      <VoucherList searchTerm={searchTerm} filterValues={filterValues} />

      <VoucherForm />
    </>
  )
}

export default Voucher
